import React, {Suspense} from 'react';
import styles from './Home.module.css';
import Cover from '../Components/Cover';
import AboutUs from '../Components/AboutUs';
import AboutUs2 from '../Components/AboutUs2';
import Social from '../Components/Social';
import Social2 from '../Components/Social2';
import Private from '../Components/Private';
import Safe from '../Components/Safe';
import Safe2 from '../Components/Safe2';
import Intuitive from '../Components/Intuitive';
import Intuitive2 from '../Components/Intuitive2';
import Authentic from '../Components/Authentic';
import Footer from '../../Desktop/Components/Footer'; 

const Home = ({onNavigate}) => {
  return (
    <main className={styles.home}> 
       
      <Suspense fallback={<div style={{ height: '120vw' }} />}>
      <Cover />
      </Suspense>
      <Suspense fallback={<div style={{ height: '120vw' }} />}>
      
      <AboutUs />
      </Suspense>
      <Suspense fallback={<div style={{ height: '120vw' }} />}>
      
      <AboutUs2 />
      </Suspense>
      <Suspense fallback={<div style={{ height: '120vw' }} />}>
     
      <Social />
      </Suspense>
      <Suspense fallback={<div style={{ height: '120vw' }} />}>
      
      <Social2 />
      </Suspense>
      <Suspense fallback={<div style={{ height: '120vw' }} />}>
     
      <Private />
      </Suspense>
      <Suspense fallback={<div style={{ height: '120vw' }} />}>
      
      <Safe />
      </Suspense>
      <Suspense fallback={<div style={{ height: '120vw' }} />}>
      
      <Safe2 />
      </Suspense>
      <Suspense fallback={<div style={{ height: '120vw' }} />}>
      
      <Intuitive />
      </Suspense>
      <Suspense fallback={<div style={{ height: '120vw' }} />}>
      
      <Intuitive2 />
      </Suspense>
      <Suspense fallback={<div style={{ height: '120vw' }} />}>
      
      <Authentic />
      </Suspense>
      <Footer onNavigate={onNavigate}/> 
    </main>
  );
};

export default Home;
